import gql from 'graphql-tag';

const APPROVED_OTA_FIRMWARE_VERSION_LIST = gql`
  query Query {
    getApprovedOTAFirmwareList {
      code
      data {
        version
        OTASubmittedBy
        OTASubmittedOn
        deviceType
        status
        OTASubmittedByName
        hardwareVersion
        url
      }
    }
  }
`;

export default APPROVED_OTA_FIRMWARE_VERSION_LIST;
